$(document).ready(function() {
    function handleSelection() {
        var group_name = $('.material-item.selected').attr('data-group');
        var select_option = $('#var_get1412 select#SingleOptionSelector-1').find(":selected").val();
        var select_option_2 = $('#var_get1412 select#SingleOptionSelector-2').find(":selected").val();
        var leadTime = $(".material-item.selected").attr('data-leadtime');
        var modal_no = $(".material-item.selected").attr('data-vf-model');
        var color_name = $(".material-item.selected").attr('data-display-title');
        var fabric_name = $(".material-item.selected").attr('data-vf-fabric');
        var leather_name = $('.material-item.selected').attr('data-vl-fabric');
        var leather_modal = $('.material-item.selected').attr('data-vl-model');
        var leg_color = $('.material-item.selected').attr('data-legs-color');
        var wood = $('.material-item.segmentWood.selected').attr('data-display-title');
       if (color_name && (color_name.includes("COM") || color_name.includes("COL"))) {
            color_name = "TBD";
        }

        var manufacturer = $('.material-item.selected').attr('data-manufacturer');
        var yardage = $('.material-item.selected').attr('data-yardage');
        var total_value = $('.material-item.selected').attr('data-total-value');
        var pattern = $('.material-item.selected').attr('data-pattern');
        var application = $('.material-item.selected').attr('data-application');
        var approval = $('.material-item.selected').attr('data-approval');
        var knit = $('.material-item.selected').attr('data-knit');
        
        $('.material-item.selected').each(function() {
            var load_img = $(this).attr('data-image');
            var optionName = $(this).attr('data-display-title');
            var materialSelectorGroup = $(this).closest('.materials').attr('data-material-options');
            $('.material-selector[data-material-options="' + materialSelectorGroup + '"] .swatch-selected-value').attr('data-display-title', optionName);
            $('.material-selector[data-material-options="' + materialSelectorGroup + '"] .swatch .swatch-image').css('background-image', 'url(' + load_img + ')');
        });

        var selected_name = fabric_name || leather_name;
        var selected_modal = modal_no || leather_modal;
        
        var finalop = '';
        if (group_name) {
            finalop += group_name;
        }
        if (select_option) {
            finalop += (finalop ? ' / ' : '') + select_option;
        }
        if (select_option_2) {
            finalop += (finalop ? ' / ' : '') + select_option_2;
        }

        $('.custom__variantcomb option').removeAttr('selected');

        var comoboo_cst_mm = $(".custom__variantcomb option").map(function() {
            return $(this).text().trim();
        }).get();

        $('.custom__variantcomb option').removeAttr("selected");

        if (jQuery.inArray(finalop.toString(), comoboo_cst_mm) >= 0) {
            $('.custom__variantcomb option').filter(function() {
                return $(this).text().trim() === finalop;
            }).attr("selected", "selected");
            
            var pro_var_id = $(".custom__variantcomb").find(":selected").val();
            var price = $(".custom__variantcomb").find(":selected").attr('variant-data-price');
            var compare_price = $(".custom__variantcomb").find(":selected").attr('variant_compare-price');
            var percent_discount = $(".custom__variantcomb").find(":selected").attr('percent-discount');
            var sku = $(".custom__variantcomb").find(":selected").attr('data-var-sku');
            var qtyval = $(".custom__variantcomb").find(":selected").attr('qty');
            var var_img = $(".custom__variantcomb").find(":selected").attr('data-img');
            var Col_com = $(".custom__variantcomb").find(":selected").attr('data-option');
            if (group_name.toLowerCase().includes('leather')) {
                $('input.seating_modal').attr('name', 'properties[Leather Model]');
                $('input.seating_color').attr('name', 'properties[Leather Color]');
                $('input.seating_name').attr('name', 'properties[Leather Name]');
            } else {
                $('input.seating_modal').attr('name', 'properties[Fabric Model]');
                $('input.seating_color').attr('name', 'properties[Fabric Color]');
                $('input.seating_name').attr('name', 'properties[Fabric Name]');
            }

            $('#demo2-1').html(select_option);
            $('#demo2-2').html(select_option_2);
            $('.product__media-item.is-active .product__media img').attr('src', var_img);
            $('.product__media-item.is-active .product__media img').attr('srcset', var_img);
            $(".custom_main__price").html(price);
            $('.custom_compareprice').html(compare_price);
            $('.custom_per_dis').html(percent_discount);
           $('.seating_shipping').val(leadTime ? leadTime.toLowerCase() : '');
            $('.seating_sku').val(sku);
            $('.detailss__sku').html(sku);
            $('.seating_modal').val(selected_modal);
            $('.seating_color').val(color_name);
            $('.seating_name').val(selected_name);
            $('.seating_leg').val(leg_color);
            $('.custom_seating').val(pro_var_id);
            $('.seating_wood').val(wood);
          if (Col_com && (Col_com.includes("COM") || Col_com.includes("COL"))) {
            $('.seating_manufacturer').val(manufacturer);
            $('.seating_yardage').val(yardage);
            $('.seating_total_value').val(total_value);
            $('.seating_pattern').val(pattern);
            $('.seating_application').val(application);
            $('.seating_backing').val(knit);
            $('.seating_approval').val(approval);
           }else{
            $('.seating_manufacturer').val('');
            $('.seating_yardage').val('');
            $('.seating_total_value').val('');
            $('.seating_pattern').val('');
            $('.seating_application').val('');
            $('.seating_backing').val('');
            $('.seating_approval').val('');
           }

            if (qtyval === 'true') {
                setTimeout(function() {
                    $('.button_seating').removeAttr('disabled').find('span').text('Add to cart');
                }, 100);
            }
        } 
    }

    $('select#SingleOptionSelector-1').on('change', handleSelection);
    $('select#SingleOptionSelector-2').on('change', handleSelection);
    $('.material-item').on('click', handleSelection);

    handleSelection();
});
